module.exports = __webpack_public_path__ + "img/thumbnail-monkey.8f482c7e.jpg";